import { Link } from "react-router-dom";
import { Infinity } from "lucide-react";
import { COMPANY } from "../lib/brand";

const COLS = [
 { title: "Our Businesses", links: [["Marketing","/#marketing"],["Consulting","/#consulting"],["Entertainment ↗","https://eoninfinityentertainment.com/"],["E.O.N. Boerboels","/boerboels"]] },
 { title: "Company", links: [["Corporate Home","/"],["Digital resources","/academy"],["Business programs","/programs"],["Contact","/contact"],["Sign In","/login"]] },
];

export function Footer() {
  return (
    <footer className="corporate-footer border-t border-eon-border bg-eon-surface mt-24">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-xl bg-eon-gold flex items-center justify-center"><Infinity size={20} className="text-white" strokeWidth={2.75} /></span>
              <span className="leading-none"><span className="block font-display font-black text-lg tracking-tight text-eon-text">E.O.N</span><span className="block text-[9px] font-bold tracking-[0.25em] text-eon-muted mt-0.5">INFINITY INC</span></span>
            </Link>
            <p className="text-sm text-eon-muted leading-relaxed max-w-xs">
              Marketing, business consulting, entertainment and canine ventures — distinct businesses, connected by E.O.N. Infinity Inc.
            </p>
            <div className="mt-5 space-y-1 text-xs text-eon-muted">
              <div className="text-eon-text/80 font-semibold">{COMPANY.legalName}</div>
              <div>{COMPANY.address1}</div>
              <div>{COMPANY.address2}</div>
              <div>{COMPANY.city}</div>
              <a href={`tel:${COMPANY.phone}`} className="block hover:text-eon-gold transition-colors">{COMPANY.phone}</a>
              <a href={`mailto:${COMPANY.email}`} className="block hover:text-eon-gold transition-colors">{COMPANY.email}</a>
            </div>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <div className="eon-label mb-4">{c.title}</div>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={to}>
                    <a href={to} target={to.startsWith("https:") ? "_blank" : undefined} rel={to.startsWith("https:") ? "noopener noreferrer" : undefined} className="text-sm text-eon-text/70 hover:text-eon-gold transition-colors">{label}{to.startsWith("https:") && <span className="block text-xs">External site · opens a new tab</span>}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <details className="corp-resource-details mt-8"><summary>Boerboels resources</summary><Link to="/dogs">Dogs</Link><Link to="/services">Marketplace</Link><Link to="/boerboels/academy">Academy &amp; e-books</Link><Link to="/breeders">Breeders</Link><Link to="/membership">Membership</Link><Link to="/community">Community</Link><Link to="/boerboels/programs">Owner programs</Link><Link to="/partners">Partners</Link><Link to="/shop">Shop</Link><Link to="/trust-safety">Trust &amp; Safety</Link></details><div className="mt-12 pt-8 border-t border-eon-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="eon-label text-eon-gold">{COMPANY.legalName} · Business. Experiences. Community.</div>
            <p className="text-xs text-eon-muted">© 2026 {COMPANY.legalName}. All rights reserved. · {COMPANY.domain}</p>
          </div>
          <p className="text-xs text-eon-muted max-w-2xl mt-4">
            E.O.N is the anchor brand. Third-party listings are the responsibility of their sellers. Marketplace listings are not E.O.N-owned or E.O.N-guaranteed inventory unless clearly labeled E.O.N Owned.
          </p>
        </div>
      </div>
    </footer>
  );
}
